<div class="main-panel">
    <div class="d-flex">
        <div>
            <div class="d-flex pt-2">
                <div class="h-30p">
                    <input
                        type="text"
                        class="form-control text-box-size shadow-sm gks-search-input"
                        placeholder="Search"
                        [(ngModel)]="searchSite"
                        (keyup.enter)="searchNewTerm()"
                        (input)="onSearchTextChange()"
                        [attr.id]="'gyan-knowledge-textbox'"
                        [attr.data-test]="'gyan-knowledge-textbox'"
                    />
                    <div
                        class="cursor-pointer clear-icon icon-clear-gks-pos"
                        [attr.id]="'gyan-knowledge-clearsearch'"
                        [attr.data-test]="'gyan-knowledge-clearsearch'"
                        (click)="clearSearch()"
                        *ngIf="searchSite !== ''"
                    ></div>
                </div>

                <div class="form-control search-client"></div>

                <div class="cursor-pointer search-term-icon" (click)="searchNewTerm()" [attr.id]="'gyan-knowledge-search'" [attr.data-test]="'gyan-knowledge-search'"></div>
            </div>
        </div>

        <div class="d-flex" class="submit-button pt-2">
            <button
                [attr.id]="'gyan-knowledge-createbutton'"
                [attr.data-test]="'gyan-knowledge-createbutton'"
                class="create-button d-flex"
                #createButton
                (click)="openCreateForm(gksCreateAndEditModel)"
            >
                <div class="icon-plus"></div>
                <div class="pl-5p">Knowledge Store</div>
            </button>
        </div>
    </div>
    <div class="table-container">
        <div
            [ngClass]="{
                'height-table-div': knowledgeStores?.length == 10,
                'height-table-div-overflow': knowledgeStores?.length < 10 && knowledgeStores?.length <= 4,
            }"
        >
            <table class="custom-table" [ngClass]="{ 'custom-table-loading': isLoadingData }">
                <thead class="custom-table-head">
                    <tr>
                        <th class="w-25">Knowledge Store</th>
                        <th class="w-25">Description</th>
                        <th class="w-40">User Groups</th>
                        <th class="w-10p actions-text">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="knowledgeStores?.length > 0 && !isLoadingData">
                        <tr *ngFor="let group of knowledgeStores; let i = index" class="h-35p">
                            <td>
                                <div class="display-ellipsis" title="{{ group.name }}">
                                    {{ group.name }}
                                </div>
                            </td>
                            <td>
                                <div class="display-ellipsis" title="{{ group.description }}">
                                    {{ group.description }}
                                </div>
                            </td>
                            <td>
                                <div
                                    class="actions-container d-flex"
                                    [ngClass]="{ 'actions-container-position': knowledgeStores?.length < 10 || (knowledgeStores?.length === 10 && i + 1 > 5) }"
                                >
                                    <div
                                        class="cursor-pointer"
                                        (click)="toggleList(i, $event)"
                                        [attr.id]="'gyan-knowledge-ug' + i"
                                        [attr.data-test]="'gyan-knowledge-ug' + i"
                                        [ngClass]="{ 'icon-active-eye': activeAccessList === i, 'icon-eye': activeAccessList != i }"
                                        *ngIf="group.access?.length > 0"
                                    ></div>
                                    <div class="display-ellipsis">
                                        {{ group.userGroups | truncateWords: 5 }}
                                    </div>
                                    <div
                                        class="access-popup-position"
                                        [ngClass]="{
                                            'popup-access': knowledgeStores?.length === 10 && i + 1 <= 5,
                                            'popup-up-access': knowledgeStores?.length < 10 || (knowledgeStores?.length === 10 && i + 1 > 5),
                                        }"
                                        *ngIf="activeAccessList === i"
                                    >
                                        <ul *ngFor="let access of group.access" class="d-flex popup-container label-style">
                                            <li class="label-white-space">{{ access.lable }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </td>
                            <!-- <td>
                                <div class="display-ellipsis" title="{{ group.userGroups }}">
                                    {{ group.userGroupLables }}
                                </div>
                            </td> -->
                            <td class="actions-text">
                                <div class="actions-container" (click)="$event.stopPropagation()">
                                    <fa-icon class="p-1 cursor-pointer d-flex align-items-center align-vertical-item" [icon]="faEllipsisV" (click)="togglePopup(i, $event)">
                                    </fa-icon>
                                    <div
                                        *ngIf="activePopupIndex === i"
                                        class="popup"
                                        (click)="$event.stopPropagation()"
                                        [attr.id]="'gyan-knowledge-edit' + i"
                                        [attr.data-test]="'gyan-knowledge-edit' + i"
                                        [ngClass]="{
                                            'popup-down': !(knowledgeStores.length >= 9 && i >= knowledgeStores.length - 2),
                                            'popup-up': knowledgeStores.length >= 9 && i >= knowledgeStores.length - 2,
                                        }"
                                    >
                                        <div class="d-flex cursor-pointer popup-container" (click)="editSite(group, gksCreateAndEditModel)">
                                            <div class="edit-icon"></div>
                                            <div class="popup-item">Edit</div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>

                    <tr *ngIf="knowledgeStores?.length === 0">
                        <td colspan="5" class="no-user-text">No Knowledge Stores available with the searched text</td>
                    </tr>
                    <tr *ngIf="isLoadingData">
                        <td colspan="5" class="text-center text-secondary">
                            <div class="p-1">
                                <div class="d-flex justify-content-center">
                                    <div class="padding-summary">Loading..</div>
                                    <div><img src="../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="display-pagination" [ngClass]="{ 'display-mobile-pagination': isMobile }" *ngIf="!isLoadingData && knowledgeStores?.length > 0">
                <div>{{ startItem }} to {{ endItem }} Items of {{ totalItems }}</div>
                <div class="user-pagination pt-2 px-2">
                    <pagination
                        [totalItems]="totalItems"
                        [(ngModel)]="currentPage"
                        [maxSize]="5"
                        class="justify-content-center pagination mb-0 px-0"
                        previousText="&lsaquo;"
                        nextText="&rsaquo;"
                        firstText="&laquo;"
                        lastText="&raquo;"
                        [boundaryLinks]="true"
                        [rotate]="false"
                        (pageChanged)="onPageChanged($event)"
                    >
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #gksCreateAndEditModel let-modal>
    <div>
        <div class="modal-dialog m-0">
            <div class="modal-content text-center">
                <div class="modal-header fw-600 create-ug-header">
                    <div *ngIf="!disableForm">Create Knowledge Store</div>
                    <div *ngIf="disableForm">Edit Knowledge Store</div>
                    <!-- <div class="cursor-pointer btn-close close-form" (click)="closeCreateandEditForm()"></div> -->
                    <div
                        type="button"
                        class="gyan-popup-close"
                        aria-label="Close"
                        (click)="closeCreateandEditForm()"
                        [attr.id]="'gks-modal-close'"
                        [attr.data-test]="'gks-modal-close'"
                    >
                        <div class="modal-close-icon"></div>
                    </div>
                </div>
                <div class="modal-body ug-form-body">
                    <div class="mb-3">
                        <div class="label-form">Knowledge Store</div>
                        <div class="ug-name-div">
                            <input
                                type="text"
                                class="form-control text-box-size shadow-sm ug-name"
                                placeholder="Enter Gyan Store Name"
                                [attr.id]="'gks-name-textbox'"
                                [attr.data-test]="'gks-name-textbox'"
                                [(ngModel)]="gksnametextbox"
                                [disabled]="disableForm"
                                (keypress)="restrictInput($event)"
                                (blur)="validateField('gksnamefield')"
                            />
                            <div class="error-message" *ngIf="errors['gksnamefield'] && !disableForm">
                                {{ errors['gksnamefield'] }}
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="label-form">Id</div>
                        <div class="ug-desc-div">
                            <input
                                type="text"
                                class="form-control text-box-size shadow-sm ug-desc-input"
                                placeholder="Enter Id"
                                [attr.id]="'gks-id-textbox'"
                                [attr.data-test]="'gks-id-textbox'"
                                [(ngModel)]="idText"
                                [disabled]="disableForm"
                                (keypress)="restrictInput($event)"
                                (blur)="validateField('gksidfield')"
                            />
                            <div class="error-message" *ngIf="errors['gksidfield'] && !disableForm">
                                {{ errors['gksidfield'] }}
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="label-form">Description</div>
                        <div class="ug-desc-div">
                            <input
                                type="text"
                                class="form-control text-box-size shadow-sm ug-desc-input"
                                placeholder="Enter Name"
                                [attr.id]="'gks-desc-textbox'"
                                [attr.data-test]="'gks-desc-textbox'"
                                (keypress)="restrictInput($event)"
                                [(ngModel)]="descriptionText"
                            />
                        </div>
                    </div>

                    <div class="label-form">User Group</div>
                    <div class="access-dropdown">
                        <app-multi-select-dropdown
                            id="selectedClient"
                            class="multi-select-option form-control shadow-sm access-form"
                            [items]="options"
                            [selectedItems]="selectedUserGroup"
                            selectedProp="userGroupId"
                            displayname="label"
                            [selectedCountText]="selectedUgCountText"
                            [selectedBlankText]="selectedUgBlankText"
                            (selectedItemsChange)="onSelectionUgChange($event)"
                        ></app-multi-select-dropdown>
                        <div class="error-message" *ngIf="errors['selectedUserGroup']">
                            {{ errors['selectedUserGroup'] }}
                        </div>
                    </div>

                    <div class="mt-3">
                        <div class="d-flex justify-content-end pt-30p">
                            <button
                                class="create-btn"
                                *ngIf="!disableForm"
                                (click)="createNewGKS()"
                                [attr.id]="'gyan-knowledge-createNew'"
                                [attr.data-test]="'gyan-knowledge-createNew'"
                                [disabled]="!isFormValid()"
                            >
                                Create
                            </button>
                            <button
                                class="create-btn"
                                *ngIf="disableForm"
                                (click)="editGks()"
                                [attr.id]="'gyan-knowledge-editSave'"
                                [attr.data-test]="'gyan-knowledge-editSave'"
                                [disabled]="!isFormValid()"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                    <!-- </form> -->
                </div>
            </div>
        </div>
    </div>
</ng-template>
